export const OFOCodes = 'OFOCodes';
export const JobTitles = 'JobTitles/';
export const GetJobTitles = OFOCodes;
export const GetGroupedOfoCodes = OFOCodes + '/grouped';